module.exports = __webpack_public_path__ + "img/77ne.0c97583d.svg";